import {
  Button,
  Card,
  CardContent,
  Divider,
  Grid,
  IconButton,
  TextField,
  Typography
} from "@material-ui/core";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import EditIcon from "@material-ui/icons/Edit";
import StorefrontIcon from "@material-ui/icons/Storefront";
import FormSpacer from "@saleor/components/FormSpacer";
import { useTemplateStyles } from "@saleor/dropOff/styles/templates";
import { GetTemplate_template_taskAreas_edges_node_tenants } from "@saleor/dropOff/types/GetTemplate";
import { TemplateAction } from "@saleor/dropOff/utils/handlers";
import * as React from "react";

interface DropOffTaskAreaCardProps {
  disableRename: boolean;
  disableAddRemove: boolean;
  taskAreaName: string;
  taskAreaId?: any;
  tenants: GetTemplate_template_taskAreas_edges_node_tenants;
  onRename: (taskAreaId: string, newTaskAreaName: string) => void;
  onClickedAddRemove?: (val) => void;
  templateAction: TemplateAction;
}

const DropOffTaskAreaCard: React.FC<DropOffTaskAreaCardProps> = props => {
  const {
    disableRename,
    disableAddRemove,
    taskAreaName,
    taskAreaId,
    tenants,
    onRename,
    onClickedAddRemove,
    templateAction
  } = props;

  const classes = useTemplateStyles(props);

  const [renameTaskAreaNewValue, setRenameTaskAreaNewValue] = React.useState(
    ""
  );
  const [inRenameStage, setInRenameStage] = React.useState<boolean>(false);

  const clickRename = () => {
    setRenameTaskAreaNewValue(taskAreaName);
    setInRenameStage(true);
  };

  const clickSaveRename = () => {
    onRename(taskAreaId, renameTaskAreaNewValue);
    setInRenameStage(false);
  };

  return (
    <Card className={`${classes.dropOffHomeLocationCard}`}>
      <CardContent>
        {inRenameStage ? (
          <Grid container spacing={2}>
            <Grid item xs={10}>
              <TextField
                label="Rename Task Area"
                variant="standard"
                fullWidth
                value={renameTaskAreaNewValue}
                onChange={c => {
                  if (c.target.value.length > 20) {
                    return;
                  }
                  setRenameTaskAreaNewValue(c.target.value);
                }}
              />
            </Grid>
            <Grid item xs={2} className={classes.circleContainer}>
              <CloseIcon
                color="secondary"
                onClick={() => setInRenameStage(false)}
              />
              <CheckIcon color="primary" onClick={() => clickSaveRename()} />
            </Grid>
          </Grid>
        ) : (
          <Grid container spacing={2}>
            <Grid item xs={10}>
              <Typography
                variant="h5"
                className={classes.dropOffCardAccordionMediumTitle}
              >
                {taskAreaName}
              </Typography>
            </Grid>
            <Grid item xs={2} className={classes.circleContainer}>
              {(templateAction === TemplateAction.EDIT ||
                templateAction === TemplateAction.CREATE) && (
                <IconButton
                  className={classes.padding0}
                  onClick={() => clickRename()}
                  disabled={disableRename}
                >
                  <EditIcon color={disableRename ? "disabled" : "secondary"} />
                </IconButton>
              )}
            </Grid>
          </Grid>
        )}

        <FormSpacer spacing={1} />
        <Divider variant="fullWidth" />
        <FormSpacer spacing={1} />

        <Grid container>
          <Grid item xs={6} className={classes.taskAreaCardStores}>
            <StorefrontIcon color="primary" />
            <span
              color="primary"
              className={classes.taskAreaCardStoresText}
              onClick={
                templateAction === TemplateAction.VIEW
                  ? onClickedAddRemove
                  : null
              }
            >
              {tenants?.totalCount} Assigned Stores
            </span>
          </Grid>
          <Grid item xs={6} className={classes.taskAreaCardButton}>
            {(templateAction === TemplateAction.EDIT ||
              templateAction === TemplateAction.CREATE) && (
              <Button
                onClick={onClickedAddRemove}
                color="primary"
                variant="outlined"
                className={classes.taskAreaCardAddRemove}
                disabled={disableAddRemove}
              >
                <Typography
                  className={
                    disableAddRemove
                      ? `${classes.textGray} ${classes.taskAreaCardAddRemoveText}`
                      : `${classes.textPrimary} ${classes.taskAreaCardAddRemoveText}`
                  }
                >
                  ADD/REMOVE
                </Typography>
              </Button>
            )}
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default DropOffTaskAreaCard;
